import { relations } from 'drizzle-orm';
import { roleResourcePermissions } from '../models/roleResourcePermissions';
import { roles } from '../models/roles';

/**
 * @group RoleResourcePermission
 * @summary RoleResourcePermission relations for the database schema
 *
 * @remarks
 * Defines the relationships for the roleResourcePermissions table, including role and targetRole.
 *
 * @example
 * ```typescript
 * import { roleResourcePermissionRelations } from '@shared/db';
 *
 * // Query roleResourcePermission with role and targetRole
 * const permissionWithDetails = await db.query.roleResourcePermissions.findFirst({
 *   where: eq(roleResourcePermissions.id, permissionId),
 *   with: {
 *     role: true,
 *     targetRole: true
 *   }
 * });
 * ```
 */
export const /**
 * @internal
 */
roleResourcePermissionRelations = relations(roleResourcePermissions, ({ one }) => ({
  role: one(roles, {
    fields: [roleResourcePermissions.role_id],
    references: [roles.id],
  }),
  targetRole: one(roles, {
    fields: [roleResourcePermissions.target_role_id],
    references: [roles.id],
    relationName: 'targetRole',
  }),
})); 